import { render, staticRenderFns } from "./subscribe.vue?vue&type=template&id=e5d4ca2a"
import script from "./subscribe.vue?vue&type=script&lang=js"
export * from "./subscribe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SubscribeHeader: require('/workspace/components/subscribe/header/index.vue').default})
